// Takes date and timeToRead (in minutes) and generates subheader
// text. Used in 2 components
export const createSubheader = (date, timeToRead) => {
  return `${date} • ${timeToRead} min read`
}
